import { object, string, ValidationError } from 'yup'

import { AlmacenInputProps } from '../interfaces'

export const almacenActualizarValidator = async (
  input: AlmacenInputProps,
): Promise<Array<string>> => {
  const schema = object({
    nombre: string().required('Ingrese el nombre'),
    ubicacion: string().required('Ingrese la ubicación'),
    codigoSucursal: object().required('Seleccione la sucursal'),
  })
  try {
    await schema.validate(input, { abortEarly: false })
    return []
  } catch (error) {
    if (error instanceof ValidationError) {
      const errors: Array<string> = error.inner.map((err) => err.message)
      return errors
    } else {
      throw error
    }
  }
}

export const AlmacenActualizarValidationSchema = object({
  nombre: string().required('Ingrese el nombre'),
  ubicacion: string().required('Ingrese la ubicación'),
  codigoSucursal: object().required('Seleccione la sucursal'),
})
